module.exports = "/static/assets/7da192543f5921c1d541937198c0afa9.gif";